import { css } from 'styled-components';

// TODO - set prefered breakpoint values

export const media = {
  xl: (...args) => css`
    @media (min-width: 1201px) {
      ${css(...args)}
    }
  `,
  lg: (...args) => css`
    @media (max-width: 1200px) {
      ${css(...args)}
    }
  `,
  md: (...args) => css`
    @media (max-width: 960px) {
      ${css(...args)}
    }
  `,
  sm: (...args) => css`
    @media (max-width: 768px) {
      ${css(...args)}
    }
  `,
  xs: (...args) => css`
    @media (max-width: 567px) {
      ${css(...args)}
    }
  `,
};
